import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "table table-bordered" }
const _hoisted_9 = { class: "text-muted" }
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = {
  style: {"width":"250px"},
  class: "text-center"
}
const _hoisted_12 = { class: "text-muted" }

import { computed, watch, onMounted, type Ref } from 'vue'

    import { SelectorSettingsReadModel } from "@Quest/PortfolioScenarios/readmodels"
    import { SelectorDialogViewModel } from "@Quest/PortfolioScenarios/Components/SelectorDialog"

    import { useSelectorSettingsQueryV1 } from "@Quest/PortfolioScenarios/queries-vue-composables"
    import { useOptimizeSelectionCommandV1 } from "@Quest/PortfolioScenarios/commands-vue-composables"

    // ======================
    // Props
    // ======================

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SelectorDialog',
  props: {
    viewModel: {}
  },
  emits: ["selected"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ======================
    // Computed (replacing class getters)
    // ======================

    const vm = computed(() => props.viewModel)

    const opened = computed(() => vm.value?.opened ?? false)

    const workspaceId = computed(() => vm.value.workspaceId)
    const portfolioId = computed(() => vm.value.portfolioId)
    const scenarioId = computed(() => vm.value.scenarioId)

    // ======================
    // Query
    // ======================

    const {
        runSelectorSettingsQueryV1,
        modelSelectorSettingsQueryV1
    } = useSelectorSettingsQueryV1(workspaceId, portfolioId, scenarioId)

    const rm = modelSelectorSettingsQueryV1 as Ref<SelectorSettingsReadModel | null>

    // ======================
    // Command
    // ======================

    const {
        invokeOptimizeSelectionCommandV1,
        succeedOptimizeSelectionCommandV1,
        result: selectionResult
    } = useOptimizeSelectionCommandV1(workspaceId, portfolioId, scenarioId)

    // ======================
    // Watch opened (replaces watch + onOpenedChanged)
    // ======================

    watch(opened, (val) =>
    {
        if (val === true)
        {
            rm.value = null
            runSelectorSettingsQueryV1()
        }
        else
        {
            selectionResult.value = null
        }
    })



    // ======================
    // Command success watcher (replaces onCommandSucceed)
    // ======================

    watch(succeedOptimizeSelectionCommandV1, (current, previous) =>
    {
        if (current && !previous)
        {
            close()
            emit("selected", selectionResult.value)
        }
    })

    // ======================
    // Methods
    // ======================

    function handleOptimizeSelectionCommand()
    {
        if (!rm.value) return

        const resources = rm.value.Resources.map(a => `${a.Id}:${a.Capacity}`)

        invokeOptimizeSelectionCommandV1({
            resources,
            totalCost: rm.value.TotalCost,
            opex: rm.value.Opex,
            capex: rm.value.Capex,
            othex: rm.value.Othex,
            expenses: rm.value.Expenses,
            opexExpenses: rm.value.OpexExpenses,
            applyBenefitsConfidenceFactor: rm.value.ApplyBenefitsConfidenceFactor
        })
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[7] || (_cache[7] = _createElementVNode("h5", { class: "modal-title" }, "Selector", -1 /* CACHED */)),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                (_unref(rm))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _cache[9] || (_cache[9] = _createElementVNode("label", null, "Risk adjusted benefits:", -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("select", {
                          class: "form-control",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(rm).ApplyBenefitsConfidenceFactor) = $event))
                        }, [...(_cache[8] || (_cache[8] = [
                          _createElementVNode("option", { value: true }, "Enabled", -1 /* CACHED */),
                          _createElementVNode("option", { value: false }, "Disabled", -1 /* CACHED */)
                        ]))], 512 /* NEED_PATCH */), [
                          [_vModelSelect, _unref(rm).ApplyBenefitsConfidenceFactor]
                        ])
                      ]),
                      _createElementVNode("table", _hoisted_8, [
                        _createElementVNode("tbody", null, [
                          _cache[11] || (_cache[11] = _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Resource"),
                            _createElementVNode("th", {
                              style: {"width":"250px"},
                              class: "text-center"
                            }, "Limit")
                          ], -1 /* CACHED */)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rm).Resources, (r) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: r.Id
                            }, [
                              _createElementVNode("td", null, [
                                _createTextVNode(_toDisplayString(r.Name), 1 /* TEXT */),
                                _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                _createElementVNode("small", _hoisted_9, _toDisplayString(r.Unit), 1 /* TEXT */)
                              ]),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  class: "form-control",
                                  "onUpdate:modelValue": ($event: any) => ((r.Capacity) = $event)
                                }, null, 8 /* PROPS */, _hoisted_10), [
                                  [
                                    _vModelText,
                                    r.Capacity,
                                    void 0,
                                    { number: true }
                                  ]
                                ])
                              ])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _cache[14] || (_cache[14] = _createElementVNode("th", null, "Budget", -1 /* CACHED */)),
                            _createElementVNode("th", _hoisted_11, [
                              _cache[12] || (_cache[12] = _createTextVNode(" Limit ", -1 /* CACHED */)),
                              _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                              _createElementVNode("small", _hoisted_12, _toDisplayString(_unref(rm).CurrencyLabel), 1 /* TEXT */)
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[15] || (_cache[15] = _createElementVNode("td", null, " Total cost ", -1 /* CACHED */)),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                class: "form-control",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(rm).TotalCost) = $event))
                              }, null, 512 /* NEED_PATCH */), [
                                [
                                  _vModelText,
                                  _unref(rm).TotalCost,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[16] || (_cache[16] = _createElementVNode("td", null, " Capex ", -1 /* CACHED */)),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                class: "form-control",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(rm).Capex) = $event))
                              }, null, 512 /* NEED_PATCH */), [
                                [
                                  _vModelText,
                                  _unref(rm).Capex,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[17] || (_cache[17] = _createElementVNode("td", null, " Opex ", -1 /* CACHED */)),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                class: "form-control",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(rm).Opex) = $event))
                              }, null, 512 /* NEED_PATCH */), [
                                [
                                  _vModelText,
                                  _unref(rm).Opex,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[18] || (_cache[18] = _createElementVNode("td", null, " Other expenses ", -1 /* CACHED */)),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                class: "form-control",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(rm).Othex) = $event))
                              }, null, 512 /* NEED_PATCH */), [
                                [
                                  _vModelText,
                                  _unref(rm).Othex,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[19] || (_cache[19] = _createElementVNode("td", null, " Expenses (All) ", -1 /* CACHED */)),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                class: "form-control",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(rm).Expenses) = $event))
                              }, null, 512 /* NEED_PATCH */), [
                                [
                                  _vModelText,
                                  _unref(rm).Expenses,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[20] || (_cache[20] = _createElementVNode("td", null, " Expenses (Opex) ", -1 /* CACHED */)),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                class: "form-control",
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(rm).OpexExpenses) = $event))
                              }, null, 512 /* NEED_PATCH */), [
                                [
                                  _vModelText,
                                  _unref(rm).OpexExpenses,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Cancel"),
                _createElementVNode("button", {
                  onClick: handleOptimizeSelectionCommand,
                  type: "button",
                  class: "btn btn-success"
                }, [...(_cache[21] || (_cache[21] = [
                  _createElementVNode("i", { class: "fa-solid fa-robot fa-bounce mr-1" }, null, -1 /* CACHED */),
                  _createTextVNode(" Optimize now ", -1 /* CACHED */)
                ]))])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})